import CommsCenter from 'components/practice/comms_center/CommsCenter';
import ContactsPage from 'components/practice/comms_center/Contacts/ContactsPage';
import NewArchivedFaxes from 'components/practice/comms_center/fax/ArchivedFaxes/NewArchivedFaxes';
import CoverPages from 'components/practice/comms_center/fax/CoverPages/CoverPages';
import DraftFaxes from 'components/practice/comms_center/fax/Drafts/DraftFaxes';
import Fax from 'components/practice/comms_center/fax/Fax/Fax';
import NewInboundFaxes from 'components/practice/comms_center/fax/InboundFaxes/NewInboundFaxes';
import Main from 'components/practice/comms_center/fax/Main/Main';
import NewOutboundFaxes from 'components/practice/comms_center/fax/OutboundFaxes/NewOutboundFaxes';

const PRACTICE_COMMS_CENTER = [
  {
    path: 'comms-center',
    element: <CommsCenter />,
    children: [
      {
        path: '',
        element: <Fax />,
        children: [
          { path: '', element: <Main /> },
          { path: 'inbound', element: <NewInboundFaxes /> },
          { path: 'outbound', element: <NewOutboundFaxes /> },
          { path: 'drafts', element: <DraftFaxes /> },
          { path: 'Archived', element: <NewArchivedFaxes /> },
          { path: 'cover-pages', element: <CoverPages /> }
        ]
      },
      {
        path: 'contacts',
        element: <ContactsPage />
      }
    ]
  }
];

export default PRACTICE_COMMS_CENTER;
